module.exports = __webpack_public_path__ + "assets/img/e16e9d8df84093c62002776c1555e77f.svg";